import React from 'react';
import { FilmEdges } from './components/FilmEdges';
import { SiteNav } from './components/SiteNav';
import { ReelProgress } from './components/ReelProgress';
import { HeroScene } from './components/sections/HeroScene';
import { PhilosophyScene } from './components/sections/PhilosophyScene';
import { KitchenScene } from './components/sections/KitchenScene';
import { CoffeeScene } from './components/sections/CoffeeScene';
import { VisitScene } from './components/sections/VisitScene';
import { MapScene } from './components/sections/MapScene';
interface AppProps {
  /** How much the imagery breathes behind the pinned type. */
  motionMode?: 'cinematic' | 'subtle' | 'still';
  /** The film sprocket strips that frame the top and bottom of the viewport. */
  showFilmEdges?: boolean;
}
export function App({
  motionMode = 'cinematic',
  showFilmEdges = true
}: AppProps) {
  return <div className="w-full bg-ink text-cream" data-id="element-0" data-mp="23vcmh01cjofb">
      {showFilmEdges && <FilmEdges data-id="element-1" data-mp="23v2tr4ox335x" />}
      <SiteNav data-id="element-2" data-mp="23ti67z10skhk" />
      <ReelProgress data-id="element-3" data-mp="3ik7eyd5x05p2" />

      <main data-id="element-4" data-mp="3ikqwhsrnks2k">
        <HeroScene motionMode={motionMode} data-id="element-5" data-mp="3ij66mgga9xb1" />
        <PhilosophyScene motionMode={motionMode} data-id="element-6" data-mp="3mlja0y7k5j4n" />
        <KitchenScene motionMode={motionMode} data-id="element-7" data-mp="3mk85uxa7a9d0" />
        <CoffeeScene motionMode={motionMode} data-id="element-8" data-mp="3rc9f0ac2njyt" />
        <VisitScene motionMode={motionMode} data-id="element-9" data-mp="3rdatypw7kqlt" />
        <MapScene data-id="element-10" data-mp="3relw6la09qat" />
      </main>
    </div>;
}